import { Component, OnInit } from "@angular/core";
import { authenticationService } from "src/app/Services/Authentication/authentication.service";
import { ViewController } from "@ionic/core";
import {
  PopoverController,
  ModalController,
  NavParams,
  ToastController,
} from "@ionic/angular";
import { SharedService } from "src/app/Services/sheared/sharedService.service";
import { Router } from "@angular/router";
import { CotationService } from "src/app/Services/Cotation/cotation.service";
import { FactoryService } from "src/app/Services/historique/factory.service";


@Component({

  selector: "app-proprio_mrhcomponent",
  templateUrl: "./proprio_mrh.component.html",
  styleUrls: ["./proprio_mrh.component.scss"],
})
export class proprio_mrhComponent implements OnInit {

  valeur:any
  valnompro:string
  valprenpro:string
  valtelpro:string
  valemail:string
  objetpass:any

  constructor(
    private viewCtrl: PopoverController,
    private _router: Router,
    private modalcontroller: ModalController,
    private nvparms: NavParams,
    private toastctl: ToastController,
    private facto: FactoryService,
    private _cotationService: CotationService
  ) {
    this.objetpass = this.facto.getData(150);
    this.objetpass.telpro=""
    this.objetpass.nomprop=""

    // this.valnompro0=""
    // this.valprenpro=""
    // this.valtelpro=""
    // this.valemail=""
  }

  ngOnInit() {
    this.valnompro=this.objetpass.nomprop
    this.valprenpro=this.objetpass.prenpro
    this.valtelpro=this.objetpass.telpro
    this.valemail=this.objetpass.emailprop
  }
  onchangemail(val){
    this.objetpass.emailprop=val.detail.value
  }
  onchangenom(val){
    this.objetpass.nomprop=val.detail.value
  }

  onchangetel(val){
    this.objetpass.telpro=val.detail.value
  }
  onchangeprenom(val){
    this.objetpass.prenpro=val.detail.value
  }
onCloseModal() {
   this.onannuler()
  }

  onannuler(){
    this.facto.sendObject.next(false)
    this.objetpass.nomprop=""
    this.objetpass.prenpro=""
    this.objetpass.telpro=""
    this.objetpass.emailprop=""
    this.modalcontroller.dismiss();
  }

  onValide() {
    
      if (this.objetpass.nomprop !==''  && this.objetpass.telpro !=="") {
        this.facto.setData(150,this.objetpass)
        setTimeout(() => {
          this.facto.sendObject.next(true)
          this.modalcontroller.dismiss();
        }, 0);

      }else{
        //this.onannuler()
      }
  }


}
